import React from 'react';
import { Avatar } from '../../shared/Avatar';
import { MasteryBar } from '../../shared/MasteryBar';
import type { SchoolData } from './types';
interface SchoolDetailPanelProps {
  school: SchoolData;
}
export function SchoolDetailPanel({
  school
}: SchoolDetailPanelProps) {
  return <div className="space-y-6" data-id="element-5139">
      <div className="grid grid-cols-3 gap-3" data-id="element-5140">
        <div className="bg-purple-50 rounded-lg p-3 text-center" data-id="element-5141">
          <div className="text-2xl font-bold text-purple-700" data-id="element-5142">
            {school.learnerCount}
          </div>
          <div className="text-xs text-purple-600" data-id="element-5143">Leerlingen</div>
        </div>
        <div className="bg-indigo-50 rounded-lg p-3 text-center" data-id="element-5144">
          <div className="text-2xl font-bold text-indigo-700" data-id="element-5145">
            {school.teacherCount}
          </div>
          <div className="text-xs text-indigo-600" data-id="element-5146">Docenten</div>
        </div>
        <div className="bg-emerald-50 rounded-lg p-3 text-center" data-id="element-5147">
          <div className="text-2xl font-bold text-emerald-700" data-id="element-5148">
            {school.avgMastery}%
          </div>
          <div className="text-xs text-emerald-600" data-id="element-5149">Gem. beheersing</div>
        </div>
      </div>

      {school.teachers.length > 0 && <div data-id="element-5150">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-5151">Docenten</h3>
          <div className="space-y-1" data-id="element-5152">
            {school.teachers.map(t => <div key={t.id} className="flex items-center gap-2 py-1.5" data-id="element-5153">
                <Avatar name={t.name} data-id="element-5154" />
                <span className="text-sm text-gray-700" data-id="element-5155">{t.name}</span>
              </div>)}
          </div>
        </div>}

      {school.learners.length > 0 && <div data-id="element-5156">
          <h3 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-5157">
            Leerlingen
          </h3>
          <div className="space-y-2" data-id="element-5158">
            {school.learners.map(learner => <div key={learner.id} className="flex items-center justify-between py-2 border-b border-gray-50 last:border-0" data-id="element-5159">
                <div className="flex items-center gap-2" data-id="element-5160">
                  <Avatar name={learner.name} data-id="element-5161" />
                  <div data-id="element-5162">
                    <div className="text-sm text-gray-800" data-id="element-5163">{learner.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-5164">
                      {learner.account && 'grade' in learner.account ? `Groep ${learner.account.grade}` : '—'}{' '}
                      · {learner.sessionCount} sessies
                    </div>
                  </div>
                </div>
                <MasteryBar value={learner.avgMastery || 0} data-id="element-5165" />
              </div>)}
          </div>
        </div>}
    </div>;
}